import { useEffect } from 'react';
import { Search, Button, Portal } from '@nazka/nazka.mapframe.components'
import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import { useNavigate } from 'react-router-dom'

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { trackEvent } from '@services/analytics.service';

import { GLOSSARY_ITEMS } from './glossary-search.constants'

import './glossary-search.styl'

function GlossarySearch({ onClose }) {
  const navigate = useNavigate()

  const { t } = useTranslation();

  useEffect(() => {
    trackEvent('glossary_search_opened');
  }, []);

  const handleSelection = (item) => {
    onClose()
    if (item?.data?.url) {
      navigate(item.data.url)
    }
  }

  const glossarySearchOptions = GLOSSARY_ITEMS.flatMap((item) => {
    const baseOption = {
      id: item.id,
      label: t('{{term}} - {{description}}', { term: t(item.term), description: t(item.description) }),
      data: { url: item.url },
    };
  
    if (!item.abbreviation) {
      return [baseOption];
    }
  
    return [
      baseOption,
      {
        id: item.id,
        label: t('{{abbreviation}} - {{description}}', { abbreviation: t(item.abbreviation), description: t(item.description) }),
        data: { url: item.url },
      },
    ];
  });

  return (
    <Portal>
      <div
        className="glossary-search__modal"
        role="dialog"
        aria-modal="true"
        aria-label={t('Search glossary')}
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) {
            onClose();
          }
        }}
      >
        <div className="glossary-search__modal__content">
          <div className="glossary-search__modal__header">
            <div className="glossary-search__modal__title">
              {t('Search glossary')}
            </div>
            <Button
              layout="ghost"
              color="black"
              icon={faXmark}
              onClick={() => onClose()}
              hover={false}
            />
          </div>
          <Search
            options={glossarySearchOptions}
            className="glossary-search__searchbar"
            placeholder={t('Search glossary')}
            onSelect={handleSelection}
            noResultsText={t('No results found')}
          />
        </div>
      </div>
    </Portal>
  )
}

export default GlossarySearch
